export enum LOCALE_KEY {
    // When player sends a life to a friend.
    BOT_SEND_LIFE_MESSAGE = 'BotSendLifeMessage',
    BOT_SEND_LIFE_CTA = 'BotSendLifeCallToAction',

    // When player requests a life from a friend.
    BOT_REQUEST_LIFE_MESSAGE = 'BotRequestLifeMessage',
    BOT_REQUEST_LIFE_CTA = 'BotRequestLifeCallToAction',

    // When player answers a life request from a friend.
    BOT_REQUEST_LIFE_ANSWER_MESSAGE = 'GotLives',

    // When player asks for help to open a gate.
    BOT_REQUEST_OPEN_GATE_MESSAGE = 'HelpMe',

    // When player helps a friend to open a gate.
    BOT_SEND_OPEN_GATE_MESSAGE = 'GotStars',

    // When player sends a gift to a friend.
    BOT_SEND_GIFT_MESSAGE = 'BotSendGiftMessage',
    BOT_SEND_GIFT_CTA = 'BotSendGiftCallToAction',

    // When player beats a friend score.
    BOT_SCORE_BEAT_MESSAGE = 'BotScoreBeatMessage',
    BOT_SCORE_BEAT_CTA = 'BotScoreBeatCallToAction',

    // When player shares its 3 star reward.
    BOT_SHARE_3_STARS_MESSAGE = 'Share3StarReward',

    // When player uses a friend help (iOS).
    BOT_HELP_FRIEND_MESSAGE = 'YourHelp',
    BOT_HELP_FRIEND_CTA = 'Play',

    // When player uses a friend help and give him an extra card.
    BOT_HELP_FRIEND_EXTRA_CARD_MESSAGE = 'YourHelpExtraCard',
    BOT_HELP_FRIEND_EXTRA_CARD_CTA = 'ClaimYourGift',

    // When player invite someone.
    BOT_INVITE_FRIEND_MESSAGE = 'BotInviteFriendMessage',

    // When player challenge someone.
    BOT_CHALLENGE_FRIEND_MESSAGE = 'BotInviteFriendMessage',
}
